import { render, staticRenderFns } from "./ViewEnforcementsTable.vue?vue&type=template&id=51d5093e"
import script from "./ViewEnforcementsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewEnforcementsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports